import React from 'react';
import { useTranslation } from 'react-i18next';

// Field type labels for display
const FIELD_TYPE_LABELS: Record<string, string> = {
  text: 'Text',
  name: 'Name',
  address: 'Address',
  radio: 'Radio',
  select: 'Dropdown',
  checkbox: 'Checkbox',
  date: 'Date',
  number: 'Number',
  narrative: 'Script/Narrative',
  button: 'Button',
  'bank-card': 'Payment Card',
  email: 'Email',
  tel: 'Phone',
};

interface SlideField {
  id?: string;
  type?: string;
  label?: string;
  required?: boolean;
  placeholder?: string;
  options?: Array<{ label?: string; value?: string }>;
  prompt?: string;
  button_text?: string;
}

interface ReviewDataFieldProps {
  data: Record<string, unknown>;
  message?: string;
  onConfirm?: () => void;
}

export function ReviewDataField({ data, message, onConfirm }: ReviewDataFieldProps): React.ReactElement {
  const { t } = useTranslation();
  const slideLabel = (data.label as string) || 'Untitled slide';
  const fields = (data.fields as SlideField[]) || [];

  return (
    <div className="sp-review-data">
      <div className="sp-review-data-header">{slideLabel}</div>

      {fields.length > 0 && (
        <div className="sp-review-data-fields">
          {fields.map((field, i) => (
            <div key={field.id || i} className="sp-review-data-field">
              <span className="sp-review-data-field-label">
                {field.label || field.button_text || `Field ${i + 1}`}
                {field.required && <span className="sp-review-data-required">*</span>}
              </span>
              <span className="sp-review-data-field-type">
                {FIELD_TYPE_LABELS[field.type ?? ''] ?? field.type ?? 'text'}
              </span>
              {field.options && field.options.length > 0 && (
                <span className="sp-review-data-field-options">
                  {field.options.map((o) => o.label || o.value).join(', ')}
                </span>
              )}
            </div>
          ))}
        </div>
      )}

      {message && <div className="sp-review-data-message">{message}</div>}

      {onConfirm && (
        <div className="sp-review-data-actions">
          <button type="button" className="sp-btn sp-btn-primary" onClick={onConfirm}>
            {t('fields.approve', 'Approve')}
          </button>
        </div>
      )}
    </div>
  );
}
